// extracted by mini-css-extract-plugin
export default {"form":"changepwd_form__QTCac","main":"changepwd_main__87ECQ"};